import { render, staticRenderFns } from "./CreateServiceSuccessModal.vue?vue&type=template&id=fa5794a2&"
import script from "./CreateServiceSuccessModal.vue?vue&type=script&lang=ts&"
export * from "./CreateServiceSuccessModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports